export default __webpack_public_path__ + "static/media/jy.0af9b38d.jpg";